import objectPath from 'object-path'
import Swal from 'sweetalert2'

const getRuleWarningTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const getRuleWarningConfig = (action = {}) => {
  return action.isWarning || action.warning || {}
}

const getRuleWarningMessage = (action = {}, value) => {
  let warningMessage =
    value !== undefined && value !== null
      ? value
      : action.value ||
        action.message ||
        objectPath.get(action, 'isWarning.warningMessage') ||
        true

  if (
    typeof warningMessage === 'string' &&
    warningMessage.trim() === ''
  ) {
    return true
  }
  return warningMessage
}

const escapeHtml = (value = '') => {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

const escapeCssValue = (value = '') => {
  return String(value || '').replace(/[;"<>]/g, '')
}

const getRuleWarningDatasourceValue = (designContext = {}, data = {}) => {
  return (
    data.datasourceValue ||
    data.datasource ||
    data.datasources ||
    objectPath.get(designContext, '@datasource') ||
    designContext.datasourceValue ||
    {}
  )
}

const getRuleWarningTitleTokenValue = (
  option = {},
  designContext = {},
  data = {},
) => {
  if (option.__isNew__) return option.value || ''

  let { jsonForm = {}, user = {}, urlParams = {} } = designContext
  let formData = data.formData || jsonForm.formData || {}
  let datasourceValue = getRuleWarningDatasourceValue(designContext, data)
  let key = option.key || option.value || option.name || ''
  let layout = option.layout || option.groupType || ''

  if (layout === 'datasources' || layout === 'datasource') {
    return objectPath.get(datasourceValue, key) ?? ''
  }
  if (layout === 'response') {
    return objectPath.get(data.response || {}, key) ?? ''
  }
  if (layout === 'urlParam' || layout === 'urlParams') {
    return objectPath.get(data.urlParams || urlParams || {}, key) ?? ''
  }
  if (layout === 'user') {
    return objectPath.get(user || {}, key) ?? ''
  }

  return (
    objectPath.get(formData, key) ??
    objectPath.get(datasourceValue, key) ??
    ''
  )
}

const createRuleWarningHtml = (
  action = {},
  designContext = {},
  data = {},
) => {
  let titleValue = action.titleValue || objectPath.get(action, 'isWarning.titleValue') || []
  if (!Array.isArray(titleValue)) return ''

  let html = []
  titleValue.forEach(({ title, fontBold, fontSize = '16px' }) => {
    if (!Array.isArray(title) || title.length === 0) return

    let htmlString = title
      .map((option) => {
        return escapeHtml(
          getRuleWarningTitleTokenValue(option, designContext, data),
        )
      })
      .join('')
    html.push(
      `<p class="mb-1 ${
        fontBold ? 'font-weight-bold' : ''
      }" style="font-size:${escapeCssValue(fontSize)}">${htmlString}</p>`,
    )
  })

  return html.join('')
}

const onRuleWarningAlert = async (
  designContext = {},
  action = {},
  data = {},
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let warningConfig = getRuleWarningConfig(action)
  let swalData = {
    icon: warningConfig.icon,
    html: createRuleWarningHtml(action, designContext, data),
    confirmButtonText: warningConfig.confirmButtonText || 'Close',
  }

  if (warningConfig.showWarningBack) {
    swalData = {
      ...swalData,
      showCancelButton: true,
      cancelButtonText: warningConfig.cancelButtonText || 'Back',
      cancelButtonColor: '#fff',
    }
  }
  if (warningConfig.showWarningReload) {
    swalData = {
      ...swalData,
      showDenyButton: true,
      denyButtonText: warningConfig.denyButtonText || 'Reload',
      denyButtonColor: '#fff',
    }
  }

  let result = await Swal.fire(swalData)
  if (result.isDenied) {
    window.location.reload()
  } else if (result.dismiss === Swal.DismissReason.cancel) {
    objectPath.set(isUiChanged, ['closeAlert'], {
      isClose: true,
      alert: warningConfig,
    })
    if (setIsUiChanged) setIsUiChanged(isUiChanged)
  }

  return result
}

export const onRuleWarning = (
  designContext = {},
  action = {},
  status = {},
  options = {},
) => {
  let {
    getRuleActionValue,
    target = '',
  } = options
  let value = getRuleActionValue
    ? getRuleActionValue(designContext, action, status)
    : options.value

  if (action.warningType === 'alert') {
    return onRuleWarningAlert(designContext, action, status)
  }

  let { elementAction = {}, setElementAction } = designContext
  let targetKey = getRuleWarningTarget(action, target)
  if (!targetKey) return undefined

  let warningConfig = getRuleWarningConfig(action)
  let warningMessage = getRuleWarningMessage(action, value)
  let warningOnSubmit =
    warningConfig.warningOnSubmit || action.mode === 'onSubmit'

  if (warningOnSubmit) {
    objectPath.set(elementAction, ['warningOnSubmit', targetKey], warningMessage)
  } else {
    objectPath.set(elementAction, ['isWarning', targetKey], warningMessage)
  }
  if (setElementAction) setElementAction(elementAction)

  return warningMessage
}
